import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=a409c46e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a409c46e')) {
      api.createRecord('a409c46e', component.options)
    } else {
      api.reload('a409c46e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=a409c46e&", function () {
      api.rerender('a409c46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EutfZZV2ZFlk/JS/videoIframe.vue"
export default component.exports